var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(86,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6036217303822938s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6036217303822938s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.44563286691441,78.14593336884907)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.8571428571428571
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5030181086519115s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5030181086519115s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.989246377572684,85.09740483854566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.7142857142857143
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4024144869215292s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4024144869215292s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.565120755512915,65.61981460823209)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.2857142857143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.5714285714285714
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3018108651911469s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3018108651911469s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.565120755512908,34.38018539176791)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.42857142857142855
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2012072434607646s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2012072434607646s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.98924637757268,14.90259516145435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.1428571428571)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.2857142857142857
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1006036217303823s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1006036217303823s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.4456328669144,21.85406663115092)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.5714285714286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#f8f8f9",
    fillOpacity: 0.14285714285714285
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "2 2;1 1",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.7042253521126761s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.236de0a77b63ef3cea6124948ce0470b.svg";
export { ForwardRef as ReactComponent };